<ng-template #balance let-acct="acct">
    <!-- balance -->
    <div class="d-flex flex-row justify-content-between">
        <div *ngIf="acct.plaidBalance !== null">
            <div class="new-balance">
                {{acct.plaidBalance | legfiCurrency:'USD':'symbol':'.2'}}
            </div>
            <div class="text-muted balance-sub">
                Bank balance
            </div>
        </div>
        <div>
            <div class="new-balance">
                {{acct.depositBankAccount.internalBalance | legfiCurrency:'USD':'symbol':'.2'}}
            </div>
            <div *ngIf="acct.plaidBalance !== null" class="text-muted balance-sub">
                PayHOA balance
            </div>
        </div>
    </div>
</ng-template>

<lf-modal *ngIf="isShowingBankAccountTipModal"
          [(show)]="isShowingBankAccountTipModal"
          title="Deposit Bank Account Help">
    <div class="text-center">
        To view available balance, please sync your bank account with PayHOA by clicking <a
        [routerLink]="['/app/settings/organization/financial-accounts', {unifiedId: unifiedLink}]">here</a>.
        Syncing your account will pull available balance and transaction history into PayHOA
    </div>
</lf-modal>

<lf-modal (closed)="isShowingPendingFundsDialog = false"
          *ngIf="isShowingPendingFundsDialog"
          [ifAddPad]="false"
          [show]="true"
          [title]="'Pending Funds'"
          class="pending-funds-info-modal">
    <div *ngIf="isPendingFundsLoading" class="d-loading">
        <div class="loader">Loading...</div>
    </div>
    <div class="table-responsive">
        <lf-datatable *ngIf="!isPendingFundsLoading"
                      [(config)]="pendingFundsConfig"
                      [(data)]="pendingDetailAccount.paymentAttempts"
                      [exportFilename]="'pending.csv'"
                      [exportable]="true">
            <tbody *ngIf="pendingDetailAccount.paymentAttempts.length > 0" class="dt-body">
            <tr *ngFor="let attempt of pendingDetailAccount.paymentAttempts">
                <td>{{attempt.createdAt | legfiDate:'MM/DD/YYYY'}}</td>
                <td>{{attempt.paymentGroup.payor.name || (attempt.paymentGroup.payor.profile ?
                    (attempt.paymentGroup.payor.profile.familyName + ', ' +
                        attempt.paymentGroup.payor.profile.givenNames) : 'Anonymous User')}}
                </td>
                <td>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType.indexOf('BankAccount') !== -1">Bank Account</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType.indexOf('CreditCard') !== -1">Credit Card</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType === 'CardToken'">Credit Card (1-time)</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType === 'OfflineCheck'">Check (offline)</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType === 'OfflineCash'">Cash (offline)</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType === 'AccountCredit'">Account Credit</span>
                    <span *ngIf="attempt.paymentGroup.paymentMethodType === 'Mailed'">Mailed Payment</span>
                </td>
                <td>{{attempt.applied | legfiCurrency:'USD':'symbol':'.2'}}</td>
                <td>{{attempt.net | legfiCurrency:'USD':'symbol':'.2'}}</td>
                <td>{{attempt.fundsAvailable ? (attempt.fundsAvailable | legfiDate:'MM/DD/YYYY') : 'Pending'}}</td>
            </tr>
            </tbody>
            <tbody *ngIf="pendingDetailAccount.paymentAttempts.length === 0" class="dt-body">
            <tr>
                <td colspan="6">No pending funds currently</td>
            </tr>
            </tbody>
        </lf-datatable>
    </div>

</lf-modal>

<!-- loader version -->
<ng-container *ngIf="isLoadingAccounts">
    <div class="card-header">
        <h2>Accounts</h2>
    </div>
    <div class="card-body">
        <div class="d-loading" style="min-height: 100px;">
            <div class="loader">Loading...</div>
        </div>
    </div>
</ng-container>


<!-- this card shows if they do not have any accounts yet -->
<ng-container *ngIf="!isLoadingAccounts && bankAccounts.length === 0">
    <div class="card-header">
        <h2>Accounts</h2>
    </div>
    <div *ngIf="jwt.superUser || jwt.admin " class="card-body">
        <div [attr.aria-label]="'Add a bank account'" (click)="addBankAccount()"
             class="add-new">
            <img src="/assets/images/payhoa/other/plus_dark_gray.svg"/>
            <br/>
            <strong>Add a Bank Account</strong>
        </div>
        <div class="list-group">
            <div class="list-group-item">
                Last deposit <strong class="float-right">$0.00</strong>
            </div>
            <div class="list-group-item">
                Pending funds<strong class="float-right">$0.00</strong>
            </div>
            <div class="list-group-item">
                Upcoming deposits <strong class="float-right">$0.00</strong>
            </div>
        </div>
    </div>
</ng-container>

<!-- this shows if they have just 1 account -->
<ng-container *ngIf="!isLoadingAccounts && bankAccounts.length === 1">
    <div class="card-header d-flex w-100 justify-content-between">
        <h2>Accounts</h2>

        <span *ngIf="hasWriteAccess" [routerLink]="['/app/settings/organization/financial-accounts']"
              class="btn btn-outline-secondary">
                <img src="/assets/images/payhoa/other/pencil.svg"/>
                Manage Accounts
            </span>
    </div>
    <div *ngFor="let acct of bankAccounts" [attr.data-account-id]="acct.id" class="card-body">
        <div class="card add-gradient mb-2">
            <div class="card-body p-3">
                <!-- bank name ... -->
                <img src="/assets/images/payhoa/dashboardEmpty/bank.svg"
                     style="width: 22px;    margin-bottom: 5px;"/>
                <div class="bank-name">
                    <span [innerHTML]="acct.friendlyName"></span>
                    <span *ngIf="acct.plaidToken?.plaidError?.errorCode === 'ITEM_LOGIN_REQUIRED' && hasWriteAccess">
                            <a [attr.aria-label]="'repair link'" (click)="fixPlaidError(acct);"
                               container="body"
                               ngbPopover="We are unable to pull transaction information from this linked bank account. This can occur if your online banking credentials change or if your bank is no longer supported. Please click the yellow icon to repair the connection"
                               popoverTitle="Needs Attention"
                               triggers="mouseenter:mouseleave">
                                <i aria-hidden="true" class="fa fa-exclamation-triangle text-warning"></i>
                            </a>
                        </span>
                </div>

                <ng-container [ngTemplateOutlet]="balance" [ngTemplateOutletContext]="{acct:acct}"></ng-container>

            </div>
        </div>
        <div class="list-group">
            <div class="list-group-item" style="padding-top: 15px; padding-bottom: 15px;">
                Last deposit
                <div *ngIf="acct.depositBankAccount.lastDeposit && acct.depositBankAccount.lastDeposit.amount < 0"
                     class="float-right">
                    <span class="text-secondary">{{acct.depositBankAccount.lastDeposit.transactionDate | legfiDate:'MM/DD/YYYY'}}</span>
                    &nbsp;
                    -
                    &nbsp;
                    <span [innerHTML]="(acct.depositBankAccount.lastDeposit.amount * -1) | legfiCurrency:'USD':'symbol':'.2'"></span>
                </div>
                <div *ngIf="!acct.depositBankAccount.lastDeposit || acct.depositBankAccount.lastDeposit === 0"
                     class="float-right">
                    <div [innerHTML]="(0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                </div>
            </div>
            <div class="list-group-item" style="padding-top: 15px; padding-bottom: 15px;">
                Pending funds

                <div *ngIf="acct.depositBankAccount.pendingFunds > 0" class="float-right">
                    <div [innerHTML]="(acct.depositBankAccount.pendingFunds || 0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                </div>
                <div *ngIf="acct.depositBankAccount.pendingFunds === 0" class="float-right">
                    <div [innerHTML]="(0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                </div>
            </div>
            <div class="list-group-item" style="padding-top: 15px; padding-bottom: 15px;">
                Upcoming deposits
                <div (click)="showPendingFundsDetail(acct.depositBankAccount)"
                     class="text-primary add-hover float-right">View Details
                </div>
            </div>

            <div *ngIf="jwt.superUser && acct.depositBankAccount.stripeManagedAccountId"
                 class="list-group-item">
                Stripe:
                <a [attr.aria-label]="'Stripe managed account'" href="https://dashboard.stripe.com/applications/users/{{acct.depositBankAccount.stripeManagedAccountId}}"
                   rel="noopener noreferrer" target="_blank" title="Stripe Managed Account">
                    <img style="vertical-align: -6px;" src="/assets/images/payhoa/other/stripe-round.png"/>
                </a>
            </div>
        </div>
    </div>

</ng-container>

<!-- this card shows if they have more than 1 account -->
<ng-container *ngIf="!isLoadingAccounts && bankAccounts.length > 1">
    <div class="card-header d-flex w-100 justify-content-between">
        <h2>Accounts</h2>

        <span [routerLink]="['/app/settings/organization/financial-accounts']"
              class="btn btn-outline-secondary">
                <img src="/assets/images/payhoa/other/pencil.svg"/>
                Manage Accounts
            </span>
    </div>

    <div class="card-body">

        <div *ngFor="let acct of bankAccounts" [attr.data-bank-account-id]="acct.id" class="card add-gradient">
            <div class="card-body p-3">
                <!-- bank name ... -->
                <div class="bank-name">
                    <span [innerHTML]="acct.friendlyName"></span>

                    <span *ngIf="acct.plaidToken && !acct.plaidAccount">
                            <a (click)="fixPlaidError(acct);"
                               container="body"
                               ngbPopover="We are unable to pull transaction information from this linked bank account. This can occur if your online banking credentials change or if your bank is no longer supported. Please click the yellow icon to repair the connection"
                               popoverTitle="Needs Attention"
                               triggers="mouseenter:mouseleave">
                                <i aria-hidden="true" class="fa fa-exclamation-triangle text-warning"></i>
                            </a>
                        </span>
                </div>

                <ng-container [ngTemplateOutlet]="balance" [ngTemplateOutletContext]="{acct:acct}"></ng-container>

                <div class="list-group">
                    <!-- last deposit -->
                    <div class="last-deposit list-group-item d-flex w-100 justify-content-between">
                        <div>Last Deposit</div>

                        <div *ngIf="acct.depositBankAccount.lastDeposit && acct.depositBankAccount.lastDeposit.amount < 0">
                            <span class="text-secondary mr-2">{{acct.depositBankAccount.lastDeposit.transactionDate | legfiDate:'MM/DD/YYYY'}}</span>
                            &nbsp;-&nbsp;
                            <span [innerHTML]="(acct.depositBankAccount.lastDeposit.amount * -1) | legfiCurrency:'USD':'symbol':'.2'"></span>
                        </div>
                        <div *ngIf="!acct.depositBankAccount.lastDeposit || acct.depositBankAccount.lastDeposit === 0">
                            <div [innerHTML]="(0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                        </div>
                    </div>

                    <!-- pending funds -->
                    <div class="pending-funds list-group-item d-flex w-100 justify-content-between">
                        <div>Pending funds</div>

                        <div *ngIf="acct.depositBankAccount.pendingFunds > 0">
                            <div [innerHTML]="(acct.depositBankAccount.pendingFunds || 0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                        </div>
                        <div *ngIf="acct.depositBankAccount.pendingFunds === 0">
                            <div [innerHTML]="(0) | legfiCurrency:'USD':'symbol':'.2'"></div>
                        </div>
                    </div>

                    <!-- upcoming dep -->
                    <div class="pending-funds list-group-item d-flex w-100 justify-content-between">
                        <div>Upcoming deposits</div>

                        <div (click)="showPendingFundsDetail(acct.depositBankAccount)" class="text-primary add-hover">
                            View Details
                        </div>
                    </div>

                    <div *ngIf="jwt.superUser && acct.depositBankAccount.stripeManagedAccountId" class="list-group-item">
                        Stripe:
                        <a [attr.aria-label]="'Stripe managed account'" href="https://dashboard.stripe.com/applications/users/{{acct.depositBankAccount.stripeManagedAccountId}}"
                           rel="noopener noreferrer" target="_blank" title="Stripe Managed Account">
                            <img style="vertical-align: -6px;" src="/assets/images/payhoa/other/stripe-round.png"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
